import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'usimweb-plot',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './plot.component.html',
    styleUrls: ['./plot.component.scss'],
    standalone: false
})
export class PlotComponent {
  @Input() data: any[] = [];
  @Input() layout: any = {};

  protected xaxis = 'Time in s';

  constructor() {}

  public onInitialized() {
    if (!this.layout) {
      this.layout = this.createLayoutTwoAxis('', 'x unit', 'y unit', 'log');
    }
  }

  protected createLayoutTwoAxis(materialName: string, unitY1: string, unitY2: string, type?: string) {
    this.layout = {
      height: 500,
      title: materialName,
      showlegend: true,
      hovermode: 'closest',
      hoverdistance: 25,
      legend: {
        x: 1,
        xanchor: 'right',
        y: 1,
      },
      yaxis2: {
        title: unitY2,
        overlaying: 'y',
        side: 'right',
        type: type,
        autorange: true,
      },
      yaxis: {
        title: unitY1,
        side: 'left',
      },
      xaxis: {
        title: this.xaxis,
      },
    };
    return this.layout;
  }
}
